import React, { useEffect, useMemo, useRef } from "react";
import ViewOptionsPanel from "../../../../components/CustomUI/ViewOptionsPanel";
import PeriodDateSelector from "../../../../components/CustomUI/PeriodDateSelector";
import { todayStr } from "./utils";
import {
  buildReportFilterSections,
  countActiveReportFilters,
} from "./buildReportFilterSections";

const ReportViewOptionsPanel = ({
  filters,
  machines = [],
  shifts = [],
  deviceModels = [],
  onApply,
  showTransFilters = false,
  showMachines = true,
  showShifts = true,
  showModel = true,
  showDates = true,
  columns = null,
  visibleColumns = [],
  onToggleColumn,
  onResetColumns,
  columnSections = [],
}) => {
  const pendingPeriodApply = useRef(false);

  const activeFilterCount = useMemo(
    () =>
      countActiveReportFilters({
        filters,
        showMachines,
        showShifts,
        showModel,
        showTransFilters,
      }),
    [
      filters,
      showMachines,
      showShifts,
      showModel,
      showTransFilters,
      filters.machineIds,
      filters.shiftId,
      filters.transModelId,
      filters.transFromStatus,
      filters.transToStatus,
    ],
  );

  const sections = useMemo(
    () =>
      buildReportFilterSections({
        filters,
        machines,
        shifts,
        deviceModels,
        showTransFilters,
        showMachines,
        showShifts,
        showModel,
        columns,
        visibleColumns,
        onToggleColumn,
        onResetColumns,
        columnSections,
      }),
    [
      filters,
      machines,
      shifts,
      deviceModels,
      showTransFilters,
      showMachines,
      showShifts,
      showModel,
      columns,
      visibleColumns,
      onToggleColumn,
      onResetColumns,
      columnSections,
    ],
  );

  useEffect(() => {
    if (!pendingPeriodApply.current) return;
    pendingPeriodApply.current = false;
    onApply?.();
  }, [filters.startDate, filters.endDate, onApply]);

  return (
    <div className="rp-report-toolbar">
      {showDates && (
        <PeriodDateSelector
          mode={filters.periodMode || "month"}
          anchorDate={filters.anchorDate}
          startDate={filters.startDate}
          endDate={filters.endDate}
          onChange={(next) => {
            pendingPeriodApply.current = true;
            filters.setPeriod(next);
          }}
          maxDate={todayStr()}
        />
      )}
      <ViewOptionsPanel
        activeFilterCount={activeFilterCount}
        sections={sections}
        onApply={onApply}
        onReset={() => {
          pendingPeriodApply.current = true;
          filters.reset();
        }}
      />
    </div>
  );
};

export default ReportViewOptionsPanel;
